import { MY_DATE_FORMATS } from '@shared/utils/date-adapter';
export { CustomDateAdapter, MY_DATE_FORMATS } from '@shared/utils/date-adapter';
import { CurrencyPipe, DatePipe, registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import localeDe from '@angular/common/locales/de';
import localeEs from '@angular/common/locales/es';
import localeFr from '@angular/common/locales/fr';
import localePt from '@angular/common/locales/pt';
import localeZh from '@angular/common/locales/zh';
import { ApplicationConfig, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MomentDateAdapter,
} from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  provideNativeDateAdapter,
} from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { AuthInterceptorService } from '@services/auth-interceptor.service';
import { NgxMaskConfig, provideEnvironmentNgxMask } from 'ngx-mask';
import { provideNgxSkeletonLoader } from 'ngx-skeleton-loader';
import { provideToastr } from 'ngx-toastr';
import { routes } from './app.routes';
import { BrowserstateInterceptor } from './interceptors/browserstate.interceptor';

import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
// Dados de idioma do moment para o MomentDateAdapter (MAT_DATE_LOCALE pt-BR); sem isso o calendário fica em inglês.
import 'moment/locale/pt-br';

registerLocaleData(localePt, 'pt-BR');
registerLocaleData(localeEs, 'es-ES');
registerLocaleData(localeFr, 'fr-FR');
registerLocaleData(localeDe, 'de-DE');
registerLocaleData(localeZh, 'zh-CN');

export const MY_DATETIME_FORMATS = {
  parse: { dateInput: 'DD/MM/YYYY HH:mm:ss' },
  display: {
    dateInput: 'DD/MM/YYYY HH:mm:ss',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

const maskConfig: Partial<NgxMaskConfig> = { validation: false };

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideToastr(),
    DatePipe,
    CurrencyPipe,
    provideAnimationsAsync(),
    provideAnimations(),
    provideNativeDateAdapter(),
    BrowserAnimationsModule,

    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: BrowserstateInterceptor, multi: true },

    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { subscriptSizing: 'dynamic' } },
    provideEnvironmentNgxMask(maskConfig),

    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    { provide: DateAdapter, useClass: MomentDateAdapter },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false } },

    provideNgxSkeletonLoader({
      theme: {
        extendsFromRoot: true,
        animation: 'pulse',
      },
    }),

    provideTranslateService({
      lang: 'pt-BR',
      fallbackLang: 'pt-BR',
      loader: provideTranslateHttpLoader({
        prefix: 'assets/languages/',
        suffix: '.json',
      }),
    }),
  ],
};
